// extracted by mini-css-extract-plugin
export var orderDetails = "_ua-2";
export var orderImage = "_ua-1";
export var orderMeta = "_ua-3";
export var orderSummary = "_ua-0";
export var rightArrow = "_ua-4";